import dayjs from 'dayjs';

const formatTimestampToDate = (timestamp = 0) => {
  const date = new Date(timestamp?.seconds * 1000);
  return dayjs(date).format('MM/DD/YYYY');
};

export default formatTimestampToDate;